/**
 * The below file contains the Sagas method for Fire Cause.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import { Error, Success } from "constants/ApiConstant";
import {
  Fire_Cause_Imported,
} from "constants/MessageConstant";
import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import { showMessage } from "redux/actions/Common";
import {
  setAllFireCause,
} from "redux/actions/FireCause";
import {
  GET_ALL_FIRE_CAUSE,
} from "redux/constants/FireCause";
import FireCauseService from "services/FireCauseService";

//#region Method for listing

/**
 * Method for getting the fire causes
 */
export function* getAllFireCause() {
  yield takeEvery(GET_ALL_FIRE_CAUSE, function* () {
    try {
      const fire = yield call(FireCauseService.getAllFireCause);
      if (fire.error != null && fire.error.message) {
        yield put(showMessage({ message: fire.error.message, type: Error }));
      } else {
        yield put(setAllFireCause(fire));
      }
    } catch (err) {
      yield put(
        showMessage({ message: err.response.data.error.message, type: Error })
      );
    }
  });
}

//#endregion Method for listing

/**
 * Method for storing the multiple Sagas method
 */
export default function* rootSaga() {
  yield all([
    fork(getAllFireCause),
  ]);
}
